import { type PropsWithChildren, useMemo } from 'react';
import { type CSSProperties } from 'styled-components';
import type { Column } from '../../types';
import { ColumnContext } from './column-context';
import { ColumnThemeProvider } from './column-theme-provider';

export interface ColumnBaseProps extends Column {
  className?: string;
  style?: CSSProperties;
}

interface ColumnContextProviderProps extends PropsWithChildren {
  index: number;
  column: Column;
  isHeadColumn: boolean;
}

export function ColumnContextProvider({
  children,
  column,
  isHeadColumn
}: ColumnContextProviderProps) {
  const context = useMemo(
    () => ({
      ...column,
      isHeadColumn
    }),
    [isHeadColumn, column]
  );

  return (
    <ColumnContext.Provider value={context}>
      <ColumnThemeProvider>{children}</ColumnThemeProvider>
    </ColumnContext.Provider>
  );
}
